import api from '../api';
import type {
  CreateBookingInput,
  ReservationBoard,
  ReservationBooking,
  RsHolidayEntry,
} from './reservation-board.service';

export type ReservationPublicBoard = ReservationBoard;
export type ReservationPublicBooking = ReservationBooking;
export type { RsHolidayEntry };

export const reservationPublicService = {
  async getBoard(shareToken: string): Promise<ReservationPublicBoard> {
    const response = await api.get<{ success: boolean; data: ReservationPublicBoard }>(
      `/reservation-system/public/${encodeURIComponent(shareToken)}/board`
    );
    return response.data.data;
  },

  async listBookings(
    shareToken: string,
    year: number,
    month: number
  ): Promise<ReservationPublicBooking[]> {
    const response = await api.get<{ success: boolean; data: ReservationPublicBooking[] }>(
      `/reservation-system/public/${encodeURIComponent(shareToken)}/bookings`,
      { params: { year, month } }
    );
    return response.data.data;
  },

  async createBookings(
    shareToken: string,
    input: CreateBookingInput
  ): Promise<ReservationPublicBooking[]> {
    const response = await api.post<{ success: boolean; data: ReservationPublicBooking[] }>(
      `/reservation-system/public/${encodeURIComponent(shareToken)}/bookings`,
      input
    );
    return response.data.data;
  },

  async deleteBooking(shareToken: string, bookingId: number, password?: string): Promise<void> {
    await api.delete(
      `/reservation-system/public/${encodeURIComponent(shareToken)}/bookings/${bookingId}`,
      { data: password ? { password } : {} }
    );
  },

  async getHolidays(
    shareToken: string,
    year: number,
    month: number,
    countryCode?: string
  ): Promise<RsHolidayEntry[]> {
    const response = await api.get<{ success: boolean; data: RsHolidayEntry[] }>(
      `/reservation-system/public/${encodeURIComponent(shareToken)}/holidays`,
      { params: { year, month, ...(countryCode ? { countryCode } : {}) } }
    );
    return response.data.data;
  },
};
